<template>
<div class="QuestionbankMsg spackage padding-20 bgc box-shadow">
    <div>
        <el-alert
            title="请您遵守国家相关规定，切勿上传低俗色情、暴力恐怖、谣言诈骗、侵权盗版等相关内容，我们保有依据国家规定及平台规则进行处理的权利。"
            type="warning"
            show-icon
            :closable="false">
        </el-alert>
    </div>
    <!-- end 警告提醒 -->

    <div class="tab-list">
        <el-button v-for="item in tablist" :key="item.code" type="primary" :plain="form.questiontype !== item.code"
                   @click="clickTab(item.code)" :disabled="typeDisabledBtn">{{item.name}}
        </el-button>
    </div>
    <!-- end 选择列表 -->

    <div class="msg">

        <el-form ref="form" :model="form" label-width="120px">
            <el-form-item label="试题分类">
                <span class="type">{{typeName}}</span>
                <el-button @click="selectType">选择分类</el-button>
            </el-form-item>

            <el-form-item label="默认分数" required v-if="form.questiontype != '7'">
                <el-input v-model="form.defaultscore" placeholder="请输入试题默认分数（可保留两位小数）"></el-input>
            </el-form-item>
            <!-- 单选 -->
            <Radio v-if="form.questiontype == '1'" :formData='form' :type="type" @cancel="_cancel" @childSubmitFormApi='childSubmitFormApi'></Radio>
            <!-- 多选 || 不定项选择题-->
            <Checkbox v-if="form.questiontype == '2' || form.questiontype == '3'" :formData='form' @cancel="_cancel"  @childSubmitFormApi='childSubmitFormApi' :type="type"></Checkbox>
            <!-- <Checkbox v-if="form.questiontype == '3'" :form='form'></Checkbox> -->
            <!-- 判断题 -->
            <Judge v-if="form.questiontype == '4'" :formData='form' @cancel="_cancel" @childSubmitFormApi='childSubmitFormApi' :type="type"></Judge>
            <!-- 填空题 -->
            <Fill v-if="form.questiontype == '5'" :formData='form' @cancel="_cancel" @childSubmitFormApi='childSubmitFormApi' :type="type"></Fill>
            <!-- 问答题 -->
            <QuestionsAndAnswers v-if="form.questiontype == '6'" :formData='form' @cancel="_cancel" @childSubmitFormApi='childSubmitFormApi' :type="type"></QuestionsAndAnswers>
            <!--材料题-->
            <material v-if="form.questiontype == '7'" :formData='form' ref="material" @cancel="_cancel" @childSubmitFormApi='childSubmitFormApi' :type="type"></material>
        </el-form>


    </div>
    <!-- end 内容区域 -->

    <QuestionbankTypePopu ref="questionbankTypePopu" @returnFatherData="requestChildData"></QuestionbankTypePopu>
    <!-- 选择分类 -->
</div>
</template>

<script>
import {mapActions} from 'vuex'
import Radio from './components/Radio'
import Material from './components/material'
import Checkbox from './components/Checkbox'
import Judge from './components/Judge'
import Fill from './components/Fill'
import QuestionbankTypePopu from './components/QuestionbankTypePopu'
import QuestionsAndAnswers from './components/QuestionsAndAnswers'
import {saveOrUpdateQuestionInfo, getQuestionInfo} from 'api/questionApi'
import {question} from 'api/enumCode'

export default {
    name: 'QuestionbankMsg',
    data() {
        return {
            tablist: question.type,
            form: {  //表单
                innerid: this.$route.query.innerid, // 试题id，新增为空
                questiontype: '', // 试题类型  1单选题 2多选题 3不定项选择题 4判断题 5填空题 6问答题 默认进来单选
                cateid: '0', // 试题分类Code
                defaultscore: '', // 试题默认分数
                subject: '', // 试题题干Html
                quesanalysis: '', // 试题解析
                isquesorder: '0', // 答案匹配顺序-填空有效 0否 1是
                isscorebyblank: '0', // 是否按空得分-填空有效 0否 1是
                referenceanswer: '', // 参考答案-问答有效
                optioninfo: [], // 试题选项信息，选择题有效，解析之后为一个数组，前端选先后顺序组装 optioncontent 选项名称 isrightanswer 是否正确答案 0否 1是
                finalanswer: '', // 填空、判断有效 1、对于判断题，答案记录为T或者F，用户提交也提交T或者F，直接对比 2、对于填空题，各个空之间以|分隔，每空有多答案以分号分隔，如果答案中含有|和分号，都替换成逗号，前端组装后提交
                questioninfo: []
            },
            type: 1, // 1新增 2编辑
            typeName: '未分类',
            typeDisabledBtn: false, // 编辑情况下不允许分类按钮可点击
        }
    },
    mounted() {
        // 判断是否为编辑情况  为编辑情况下查询当前页面信息
        if (this.form.innerid) {
            this.typeDisabledBtn = true // 不可编辑
            this.type = 2
            this.selectMsg(this.form.innerid)   // 查询页面详情接口
        } else {
            this.type = 1
            this.form.innerid=''
            this.form.questiontype = '1'
        }
    },
    methods: {
        _cancel() {
            this.$router.back()
        },
        _initForm() { // 初始化列表数据
            this.form = {  //表单
                // innerid: '', // 试题id，新增为空
                questiontype: '', // 试题类型  1单选题 2多选题 3不定项选择题 4判断题 5填空题 6问答题
                cateid: '0', // 试题分类Code
                // defaultscore: '', // 试题默认分数
                subject: '', // 试题题干Html
                quesanalysis: '', // 试题解析
                isquesorder: '0', // 答案匹配顺序-填空有效 0否 1是
                isscorebyblank: '0', // 是否按空得分-填空有效 0否 1是
                referenceanswer: '', // 参考答案-问答有效
                optioninfo: [], // 试题选项信息，选择题有效，解析之后为一个数组，前端选先后顺序组装 optioncontent 选项名称 isrightanswer 是否正确答案 0否 1是
                finalanswer: '', // 填空、判断有效 1、对于判断题，答案记录为T或者F，用户提交也提交T或者F，直接对比 2、对于填空题，各个空之间以|分隔，每空有多答案以分号分隔，如果答案中含有|和分号，都替换成逗号，前端组装后提交
                questioninfo: []
            }
            this.typeName = '未分类'
        },
        clickTab(code) {  // 列表切换
            this._initForm()
            this.form.questiontype = code
        },
        childSubmitFormApi(api) {    // 子组件提交api方法
            api = JSON.parse(api)
            console.log(api)
            if (api.questiontype == 7) {
                api.questioninfo = JSON.stringify(api.questioninfo)
                // api.questioninfo.forEach(option => {
                //     option.optionslist.forEach(item => {
                //         item.optionid += ''
                //         delete item.isrightanswerpage
                //     })
                //     option.optionslist = JSON.stringify(option.optionslist)
                //     option.questioninfo = JSON.stringify(option.questioninfo)
                // })
            } else {
                api.optioninfo.forEach(item => {
                    item.optionid += ''
                    delete item.isrightanswerpage
                })
                api.optioninfo = JSON.stringify(api.optioninfo)
                api.questioninfo = JSON.stringify(api.questioninfo)
            }
            // 判断题目
            if (api.subject.length == 0) {
                this.$message.error('题目不能为空')
                return
            } else if (!/^\d+(\.\d{1,2})?$/.test(api.defaultscore) && api.questiontype != 7) {
                this.$message.error('请输入分数且仅可保留两位小数')
                return
            } else {
                // api 接口提交
                this.setLoading(true)
                saveOrUpdateQuestionInfo({
                    data: api,
                    success: data => {
                        this.setLoading(false)
                        if (data.code == '000') {
                            this.$message.success('保存成功')
                            setTimeout(() => {
                                this.$router.push({name: 'QuestionbankList'})
                            }, 500)
                        } else {
                            this.$message.error(data.msg)
                        }
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            }
        },
        selectType() { // 选择分类
            this.$refs.questionbankTypePopu.openDialog("选择分类")
        },
        requestChildData(data) {  // 获取子类返回点方法
            let childData = JSON.parse(data)
            this.typeName = childData.label
            this.form.cateid = childData.id
            // 关闭弹窗
            this.$refs.questionbankTypePopu.closeDialog()
        },
        selectMsg(innerid) { // 查询内容
            this.setLoading(true)
            getQuestionInfo({
                data: {innerid: innerid},
                success: data => {
                    this.setLoading(false)
                    this.form = data.data
                    // 分类名称
                    this.typeName = this.form.catename
                    // 试题类型
                    this.form.questiontype = this.form.questiontype.toString()
                    if (this.form.questiontype == 7) {
                        this.$nextTick(() => {
                            this.$refs.material._setQuestionList()
                        })
                    }
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions(['setLoading'])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        Radio,
        Checkbox,
        Judge,
        Fill,
        QuestionsAndAnswers,
        QuestionbankTypePopu,
        Material
    }
}
</script>

<style lang="scss" type="text/scss" scope>
.QuestionbankMsg {
    .el-form{
        width: 870px;
    }
    textarea[name = "editorValue"] {
        display: none
    }
    .el-form-item {
        .el-form-item__label {
            text-align: left
        }
        &.is-required {
            .el-form-item__label::after {
                content: "*";
                color: #F56C6C;
                margin-left: 4px;
            }
            .el-form-item__label::before {
                display: none;
            }
        }
    }
    .type {
        margin-right: 20px;
    }
    .tab-list {
        margin-top: 30px;

        .el-button {
            margin-right: 20px;
        }
    }
    .msg {
        margin-top: 35px;
        width: 830px;
    }
}
</style>
